import { Component, OnChanges } from '@angular/core';
import * as _ from 'lodash';

import { fieldsInfo } from './fields-info';
import { BaseSegmentComponent } from '../base/_base-segment.component';
import { Config } from 'shared/config/env.config';
import { setErrors } from 'shared/digital-assets/digital-asset-helpers';
import { isAssetItemShown } from 'shared/digital-assets/digital-asset-helpers';


@Component({
  moduleId: module.id,
  selector: 'digital-assets-segment',
  templateUrl: 'digital-assets.component.html',
  styleUrls: ['digital-assets.component.scss'],
})
export class DigitalAssetsComponent extends BaseSegmentComponent implements OnChanges {
  headers: any[] = [
    'filename',
    'asset_type',
    'representation',
  ];

  Config: any = Config;
  brandRelationshipId: any;
  fieldsInfo = fieldsInfo;
  digitalAssets: any[] = [];

  ngOnChanges() {
    this.data = this.orderBy(this.data, 'sequence');
    if (this.itemDetail && this.itemDetail.digitalAssets) {
      this.digitalAssets = this.itemDetail.digitalAssets;
    }
  }

  getFileIconLink(asset: any): any {
    if (this.itemDetail && this.itemDetail.digitalAssets) {
      const filename = (asset.filename) ? asset.filename : asset.uri;
      let status = 'working';
      if (this.itemDetail.status === 8) {
          status = 'published';
      }
      return this.Config.BACKEND +
        'parts/asset/icon/' + this.itemDetail.brandRelationshipId +
        '?filename=' + filename +
        '&status=' + status;
    }
  }

  hasItemError(itemName: string, index: number): boolean {
    return this.hasError(this.getErrorPath('digitalAssets', itemName, index));
  }

  // handlers

  onImagePreviewClick($event: MouseEvent, asset: any) {
    $event.stopPropagation();
    if (asset.download_link) {
      window.open(asset.download_link, '_blank');
    }
  }

  private isFullSizeField(fieldName: string) {
    return (_.indexOf(this.fieldsInfo.fullSizeFields, fieldName) >= 0);
  }

  private isItemShown(asset: any, item: any): boolean {
    return isAssetItemShown(asset, item);
  }

  private hasSystemFile(asset: any): boolean {
    return !!asset.system_filename;
  }

  private getAssetLink(asset: any): string {
    return asset.digital_asset_id ? `/digital-asset/${asset.digital_asset_id}/details` : null;
  }
}
